import React from 'react';
import NewsList from '../components/News/NewsList';
import NewsFilterBar, {useNewsFilters} from '../components/News/NewsFilterBar';
import {toApiFilters} from '../types/cardData';

const TrendingPage: React.FC = () => {
    const {filters, setFilters} = useNewsFilters();
    const apiFilters = toApiFilters(filters);

    return (
        <div style={{padding: '5px'}}>
            <NewsFilterBar filters={filters} onChange={setFilters} />
            <NewsList
                useTrendingNews={true}
                region={apiFilters?.region}
                relevance={apiFilters?.relevance}
            />
        </div>
    );
};

export default TrendingPage;
